import { render, staticRenderFns } from "./ClimateBlock.vue?vue&type=template&id=e2fc54d2&scoped=true&"
import script from "./ClimateBlock.vue?vue&type=script&lang=js&"
export * from "./ClimateBlock.vue?vue&type=script&lang=js&"
import style1 from "./ClimateBlock.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2fc54d2",
  null
  
)

export default component.exports